import { SearchCriteriaPricingBooking } from "./../utils/SearchCriteriaPricingBooking";
import { SearchCriteria } from "./../utils/searchCriteria";
import { Http, Response, URLSearchParams } from "@angular/http";
import { AuthHttp } from "angular2-jwt";
import { EbDemande } from "./../classes/demande";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Statique } from "../utils/statique";
import { ExEbDemandeTransporteur } from "../classes/demandeTransporteur";
import { DatePipe } from "@angular/common";
import { EbUser } from "../classes/user";

@Injectable()
export class PricingService {
  Statique = Statique;
  constructor(private http: Http, private authHttp: AuthHttp) { }
  getHtmlEbDemande(ebDemandeNum: number) {
    let style = "top: 6px;cursor: pointer;",
      _type = "checkbox";
    return (
      "<input class='checkbox-Track' [ngbTooltip]='tipContent'  id=" +
      ebDemandeNum +
      "  type='" +
      _type +
      "' style='" +
      style +
      "'onchange='functions.clickCheckbox(" +
      ebDemandeNum +
      ", event.target)'>"
    );
  }
  ajouterEbDemande(ebUserNum : number, ebDemande: EbDemande) {
    this.formatDemandeDates(ebDemande);
    return this.authHttp
      .post(Statique.controllerPricing + "/add/"+ ebUserNum, ebDemande)
      .map((res: Response) => res.json());
  }
  deleteEbDemande(listEbDemandeNum: number[]) {
    return this.authHttp
      .post(Statique.controllerPricing + "/deleteDemande", listEbDemandeNum)
      .map((res: Response) => res.json());
  }

  saveEbDemande(ebDemande: EbDemande) {

    this.formatDemandeDates(ebDemande);

    return this.authHttp
      .post(Statique.controllerPricing + "/save", ebDemande)
      .map((res: Response) => res.json());
  }

  updateMotifDemande(ebDemandeNum: number, motif: string) {
    return this.authHttp.post(
      Statique.controllerPricing + "/update-motif-demande/" + ebDemandeNum,
      motif
    );
  }

  getDemandeExpedition(demandeId: number) {
    return this.authHttp
      .post(Statique.controllerPricing + "/get-demande-expedition", demandeId)
      .map((res: Response) => {
        if (res.text() != "")
          return res.json()
        else return null;
      });
  }
  
  confirmerEbDemande(ebUserNum : number, demande : EbDemande) {
    this.formatDemandeDates(demande);
    return this.authHttp
      .post(Statique.controllerPricing + "/confirmer/"+ ebUserNum, demande)
      .map((res: Response) => res.json());
  }

  deleteDemande(ebDemandeNUm: number) {
    return this.authHttp
      .post(Statique.controllerPricing + "/deleteEbDemande", ebDemandeNUm)
      .map((res: Response) => res.json());
  }
  listPays() {
    return this.http
      .get(Statique.controllerStatiqueListe + "/countries")
      .map((res: Response) => res.json());
  }

  listBroker(searchCriteria: SearchCriteria) {
    return this.authHttp
      .post(Statique.controllerPricing + "/listBroker", searchCriteria)
      .map((res: Response) => res.json());
  }

  listCostCenter(ebEtablissementNum) {
    let params = new URLSearchParams();
    params.set("ebEtablissementNum", ebEtablissementNum);
    return this.authHttp
      .get(Statique.controllerPricing + "/listCostCenters", { search: params })
      .map((res: Response) => res.json());
  }

  listCategorie(ebEtablissementNum) {
    let params = new URLSearchParams();
    params.set("ebEtablissementNum", ebEtablissementNum);
    return this.authHttp
      .get(Statique.controllerPricing + "/listCategories", { search: params })
      .map((res: Response) => res.json());
  }

  listTransporteurControlTower(searchCriteria: SearchCriteria) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/listTransporteurControlTower",
      searchCriteria
      )
      .map((res: Response) => res.json());
  }

  listTransporteur(searchCriteria: SearchCriteria) {
    return this.authHttp
      .post(Statique.controllerPricing + "/listTransporteur", searchCriteria)
      .map((res: Response) => res.json());
  }

  getEbDemande(searchCriteriaPricingBooking: SearchCriteriaPricingBooking) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/demande",
      searchCriteriaPricingBooking
      )
      .map((res: Response) => res.json());
  }
  
  checkStatusIsConfirmed(searchCriteriaPricingBooking: SearchCriteriaPricingBooking) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/checkStatusIsConfirmed",
      searchCriteriaPricingBooking
      )
      .map((res: Response) => res.json());
  }

  getListEbDemandeQuote(
    searchCriteriaPricingBooking: SearchCriteriaPricingBooking
  ) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/listDemandeQuote",
      searchCriteriaPricingBooking
      )
      .map((res: Response) => res.json());
  }

  ajouterQuotation(exEbDemandeTransporteur: ExEbDemandeTransporteur) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/addQuotation",
      exEbDemandeTransporteur
      )
      .map((res: Response) => res.json());
  }

  updateStatusQuotation(exEbDemandeTransporteur: ExEbDemandeTransporteur) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/updateStatusQuotation",
      exEbDemandeTransporteur
      )
      .map((res: Response) => res.json());
  }

  getListDocuments(ecModule, ebDemandeNum, ebExpeditionNum, ebUserNum) {
    if (ebDemandeNum == null) ebDemandeNum = "";
    if (ebExpeditionNum == null) ebExpeditionNum = "";
    if (ebUserNum == null) ebUserNum = "";
    if (ecModule == null) ecModule = "";
    return this.http
      .get(
      Statique.controllerStatiqueListe +
      "/listDocuments?module=" +
      ecModule +
      "&ebDemandeNum=" +
      ebDemandeNum +
      "&ebExpeditionNum=" +
      ebExpeditionNum +
      "&ebUserNum=" +
      ebUserNum
      )
      .map((res: Response) => res.json());
  }

  getListDemande() {
    return this.authHttp
      .get(Statique.controllerPricing + "/listDemande")
      .map((res: Response) => res.json());
  }

  getListCommandeNum(compagnieNum) {
    return this.authHttp
      .get(Statique.controllerPricing + "/listCommandeNum/" + compagnieNum)
      .map((res: Response) => res.json());
  }

  deleteDocument(doc: number) {
    return this.authHttp
      .post(Statique.controllerPricing + "/deleteDocument", doc)
      .map((res: Response) => res.json());
  }

  confirmPickup(ebDemande: EbDemande) {

    this.formatDemandeDates(ebDemande);

    return this.authHttp
      .post(Statique.controllerPricing + "/confirmPickup", ebDemande)
      .map((res: Response) => res.json());
  }

  cancelQuotation(ebDemandeNum: number) {
    return this.authHttp
      .post(Statique.controllerPricing + "/cancelQuotation", ebDemandeNum)
      .map((res: Response) => res.json());
  }

  updateEbDemandeTransportInfos(ebDemande: EbDemande) {

    this.formatDemandeDates(ebDemande);

    return this.authHttp
      .post(
      Statique.controllerPricing + "/updateEbDemandeTransportInfos",
      ebDemande
      )
      .map((res: Response) => res.json());
  }

  listAllCostCategorie() {
    return this.authHttp
      .get(Statique.controllerPricing + "/listPostCostCategorie")
      .map((res: Response) => res.json());
  }

  getTaskProgress(ident: string) {
    return this.authHttp
      .post(Statique.controllerPricing + "/getTaskProgress", ident)
      .map((res: Response) => res.json());
  }

  deleteQuotation(ebDemandeTransporteurNum: number) {
    return this.authHttp
      .post(
      Statique.controllerPricing + "/deleteQuotation",
      ebDemandeTransporteurNum
      )
      .map((res: Response) => res.json());
  }

  //-----------Expedition

  getExpedition(searchCriteriaPricingBooking: SearchCriteriaPricingBooking) {
    return this.authHttp
      .post(
      Statique.controllerExpedition + "/details",
      searchCriteriaPricingBooking
      )
      .map((res: Response) => res.json());
  }

  updateEtatDemande(sc: SearchCriteriaPricingBooking) {
    return this.authHttp
      .post(Statique.controllerExpedition + "/update-etat-commande", sc)
      .map((res: Response) => res.json());
  }

  formatDemandeDates(ebDemande: EbDemande) {
		let datepipe = new DatePipe("fr");

    ebDemande.dateCommande = datepipe.transform(
			ebDemande.dateCommande, Statique.YEAR_MONTH_DAY_PATHERN
		);

		if (ebDemande.listMarchandises)
		{
			ebDemande.listMarchandises[0].dateDispo = datepipe.transform(
				ebDemande.listMarchandises[0].dateDispo, Statique.YEAR_MONTH_DAY_PATHERN
		  );
		};
	}

  existByRef(commandeNum, etablissementNum) {
    return this.authHttp
      .get(Statique.controllerPricing + "/demande?commandeNum=" + commandeNum + "&etablissementNum=" + etablissementNum)
      .map((res: Response) => res.json());
  }

  listTypeMarchandise(ebCompagnieNum: number) {
    return this.http
      .get(Statique.controllerStatiqueListe + "/typeMarchandises?ebCompagnieNum="+ebCompagnieNum)
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pricing.service.ts